// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1o71a","right":"styles_right__1IM2l"};